import React, { useEffect } from 'react';
import { UseFormRegister, FieldErrors, UseFormWatch, UseFormTrigger, UseFormSetValue } from 'react-hook-form';
import InputDatePicker from './InputDatePicker';

interface IDateDoubleProps {
  id?: string;
  errors: FieldErrors<any>;
  register: UseFormRegister<any>;
  watch: UseFormWatch<any>;
  trigger: UseFormTrigger<any>;
  setValue: UseFormSetValue<any>;
  label: string;
  disabled?: boolean;
  required?: boolean;
}

const parseDate = (value: any): Date => {
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const [day, month, year] = value.split('/');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }
  return new Date(value);
};

const DateDouble: React.FC<IDateDoubleProps> = ({
  id,
  errors,
  register,
  watch,
  trigger,
  setValue,
  label,
  disabled,
  required
}) => {
  const idFromDate = id ? id + 'FromDate' : "FromDate";
  const idToDate = id ? id + 'ToDate' : "ToDate";

  useEffect(() => {
    register(idFromDate, {
      ...(required && {
        required: `'Inicio' de '${label}' requerido`,
      }),
      validate: (value: any) => {
        const watchToDate = watch(idToDate);
        if (value && watchToDate) {
          const fromDate = parseDate(value);
          const toDate = parseDate(watchToDate);
          return toDate >= fromDate || "'Inicio' debe ser menor o igual que 'Fin'";
        }
        return true;
      },
    });
    register(idToDate, {
      ...(required && {
        required: `'Fin' de '${label}' requerido`,
      }),
      validate: (value: any) => {
        const watchFromDate = watch(idFromDate);
        if (value && watchFromDate) {
          const toDate = parseDate(value);
          const fromDate = parseDate(watchFromDate);
          return toDate >= fromDate || "'Fin' debe ser mayor o igual que 'Inicio'";
        }
        return true;
      },
    });
  }, [register, idFromDate, idToDate, required, label, watch]);

  const handleFromDateChange = (value: string | null) => {
    setValue(idFromDate, value);
    trigger([idFromDate, idToDate]);
  };

  const handleToDateChange = (value: string | null) => {
    setValue(idToDate, value);
    trigger([idFromDate, idToDate]);
  };

  return (
    <fieldset className="input-block input-block--fieldset">
      <legend>{label}</legend>
      <div className="input-block--fieldset__group">
        <div className="container-date-start-leave">
          <legend className="input-block--fieldset__legend">Inicio</legend>
          <InputDatePicker
            id={idFromDate}
            name={idFromDate}
            disabled={disabled}
            required={required}
            value={watch(idFromDate)}
            onChange={handleFromDateChange}
            cssClass={errors[idFromDate] ? 'error-validate' : ''}
          />
        </div>
        <div className="container-date-start-leave">
          <legend className="input-block--fieldset__legend">Fin</legend>
          <InputDatePicker
            id={idToDate}
            name={idToDate}
            disabled={disabled}
            required={required}
            value={watch(idToDate)}
            onChange={handleToDateChange}
            cssClass={errors[idToDate] ? 'error-validate' : ''}
          />
        </div>
      </div>
      <div className="input-block--fieldset__group">
        <div className="container-date-start-leave">
          {errors[idFromDate] &&
            <span className="error">{errors[idFromDate].message as string}</span>
          }
        </div>
        <div className="container-date-start-leave">
          {errors[idToDate] &&
            <span className="error">{errors[idToDate].message as string}</span>
          }
        </div>
      </div>
    </fieldset>
  );
}

export default DateDouble;